import _ from "lodash";
import {
  SHOW_NAV_MENU,
  HIDE_NAV_MENU
} from "../actions/types";

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_NAV_MENU:
      return true;
    case HIDE_NAV_MENU:
      return false;
    default:
      return state;
  }
};

